import { useEffect, useState } from "react";
import { setUpdateAvailable } from "@/shared/states/notification";

export const useCheckForUpdates = () => {
  const [updateAvailable, setUpdateAvailableState] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch("/version.json", { cache: "no-store" });
        const { version } = await response.json();
        const storedVersion = localStorage.getItem("app_version");
        if (storedVersion && storedVersion !== version) {
          setUpdateAvailable(true);
          setUpdateAvailableState(true);
        }
        localStorage.setItem("app_version", version);
      } catch (error) {
        console.error("Version check failed:", error);
        return;
      }
    };

    // Check every 30 seconds
    const interval = setInterval(checkVersion, 30000);
    checkVersion(); // Initial check

    return () => clearInterval(interval);
  }, []);

  return updateAvailable;
};
